var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs"),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c("BjFormItemCode", {
                      attrs: {
                        label: _vm.$t(
                          "BusinessPurchaseReturnComPage.header.queryCode"
                        ),
                        prop: _vm.isInform ? "code" : "queryCode",
                        placeholder: _vm.isInform
                          ? ""
                          : _vm.$t(
                              "BusinessPurchaseReturnComPage.header.codeText"
                            ),
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleQuery.apply(null, arguments)
                        },
                      },
                      model: {
                        value:
                          _vm.queryParams[_vm.isInform ? "code" : "queryCode"],
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.queryParams,
                            _vm.isInform ? "code" : "queryCode",
                            $$v
                          )
                        },
                        expression:
                          "queryParams[isInform ? 'code' : 'queryCode']",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseReturnComPage.header.supplier"
                          ),
                          prop: "supplier",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t(
                              "BusinessPurchaseReturnComPage.header.supplierText"
                            ),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.supplier,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "supplier", $$v)
                            },
                            expression: "queryParams.supplier",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseReturnComPage.header.type"
                          ),
                          prop: "type",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: { "lov-code": "SPUR.STOCKOUT_TYPE" },
                          model: {
                            value: _vm.queryParams.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "type", $$v)
                            },
                            expression: "queryParams.type",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseReturnComPage.header.warehouseCode"
                          ),
                          prop: "warehouseCode",
                        },
                      },
                      [
                        _c("BjSelectWarehouse", {
                          attrs: {
                            "value-code": "code",
                            "type-code": ["logic"],
                          },
                          model: {
                            value: _vm.queryParams.warehouseCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "warehouseCode", $$v)
                            },
                            expression: "queryParams.warehouseCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseReturnComPage.header.status"
                          ),
                          prop: "status",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "lov-code": _vm.isInform
                              ? "SPUR.STOCKOUT_STATUS"
                              : "STOCK.STOCKOUT_RESULT_STATUS",
                          },
                          model: {
                            value: _vm.queryParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "status", $$v)
                            },
                            expression: "queryParams.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c("BjFormItemCode", {
                      attrs: {
                        label: _vm.$t(
                          "BusinessPurchaseReturnComPage.header.purchaseCode"
                        ),
                        prop: "purchaseCode",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleQuery.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.queryParams.purchaseCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "purchaseCode", $$v)
                        },
                        expression: "queryParams.purchaseCode",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c("BjFormItemCode", {
                      attrs: {
                        label: _vm.$t(
                          "BusinessPurchaseReturnComPage.header.spuCode"
                        ),
                        prop: "spuCode",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleQuery.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.queryParams.spuCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "spuCode", $$v)
                        },
                        expression: "queryParams.spuCode",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c("BjFormItemCode", {
                      attrs: {
                        label: _vm.$t(
                          "BusinessPurchaseReturnComPage.header.skuCode"
                        ),
                        prop: "skuCode",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleQuery.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.queryParams.skuCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "skuCode", $$v)
                        },
                        expression: "queryParams.skuCode",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("table.createTimeText") } },
                      [
                        _c("BjDateTimerangePicker", {
                          attrs: {
                            placeholder: _vm.$t("table.createTimeText"),
                          },
                          model: {
                            value: _vm.queryParamsTime_create,
                            callback: function ($$v) {
                              _vm.queryParamsTime_create = $$v
                            },
                            expression: "queryParamsTime_create",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.isInform
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseReturnComPage.header.reviewTime"
                              ),
                            },
                          },
                          [
                            _c("BjDateTimerangePicker", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "BusinessPurchaseReturnComPage.header.reviewTime"
                                ),
                              },
                              model: {
                                value: _vm.queryParamsTime_audit,
                                callback: function ($$v) {
                                  _vm.queryParamsTime_audit = $$v
                                },
                                expression: "queryParamsTime_audit",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseReturnComPage.header.deliveryTime"
                          ),
                        },
                      },
                      [
                        _c("BjDateTimerangePicker", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessPurchaseReturnComPage.header.deliveryTime"
                            ),
                          },
                          model: {
                            value: _vm.queryParamsTime_stock,
                            callback: function ($$v) {
                              _vm.queryParamsTime_stock = $$v
                            },
                            expression: "queryParamsTime_stock",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseReturnComPage.header.logisticsBusinessName"
                          ),
                          prop: "logisticsBusinessName",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.logisticsBusinessName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "logisticsBusinessName",
                                $$v
                              )
                            },
                            expression: "queryParams.logisticsBusinessName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseReturnComPage.header.logisticsNo"
                          ),
                          prop: "logisticsNo",
                        },
                      },
                      [
                        _c("BjInputCode", {
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.logisticsNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "logisticsNo", $$v)
                            },
                            expression: "queryParams.logisticsNo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function (tableOperationProp) {
              return [
                _c(
                  "el-col",
                  [
                    _vm.isInform
                      ? [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "permission",
                                  rawName:
                                    "v-permission:BusinessPurchaseReturnInformAdd",
                                  arg: "BusinessPurchaseReturnInformAdd",
                                },
                              ],
                              staticClass: "main-btn",
                              attrs: { type: "primary" },
                              on: { click: _vm.onAdd },
                            },
                            [_vm._v(_vm._s(_vm.$t("addText")))]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "permission",
                                  rawName:
                                    "v-permission:BusinessPurchaseReturnInformEdit",
                                  arg: "BusinessPurchaseReturnInformEdit",
                                },
                              ],
                              attrs: {
                                disabled: tableOperationProp.notSingle,
                                type: "primary",
                              },
                              on: { click: _vm.onEdit },
                            },
                            [_vm._v(_vm._s(_vm.$t("editText")))]
                          ),
                          _c(
                            "el-dropdown",
                            {
                              directives: [
                                {
                                  name: "hasDropdownChildren",
                                  rawName: "v-hasDropdownChildren",
                                },
                              ],
                              on: { command: _vm.onAudit },
                            },
                            [
                              _c("el-button", { attrs: { type: "primary" } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "BusinessPurchaseReturnComPage.review"
                                      )
                                    )
                                ),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-down el-icon--right",
                                }),
                              ]),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      directives: [
                                        {
                                          name: "permission",
                                          rawName:
                                            "v-permission:BusinessPurchaseReturnInform_Audit",
                                          arg: "BusinessPurchaseReturnInform_Audit",
                                        },
                                      ],
                                      attrs: {
                                        command: _vm.$t(
                                          "BusinessPurchaseReturnComPage.review"
                                        ),
                                        disabled:
                                          tableOperationProp.notSelected,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "BusinessPurchaseReturnComPage.review"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      directives: [
                                        {
                                          name: "permission",
                                          rawName:
                                            "v-permission:BusinessPurchaseReturnInform_UnAudit",
                                          arg: "BusinessPurchaseReturnInform_UnAudit",
                                        },
                                      ],
                                      attrs: {
                                        command: _vm.$t(
                                          "BusinessPurchaseReturnComPage.antiAudit"
                                        ),
                                        disabled: tableOperationProp.notSingle,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "BusinessPurchaseReturnComPage.antiAudit"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "permission",
                                  rawName:
                                    "v-permission:BusinessPurchaseReturnInform_Cancel",
                                  arg: "BusinessPurchaseReturnInform_Cancel",
                                },
                              ],
                              attrs: {
                                type: "primary",
                                disabled: tableOperationProp.notSingle,
                              },
                              on: { click: _vm.onCancel },
                            },
                            [_vm._v(_vm._s(_vm.$t("cancelText")))]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "permission",
                                  rawName:
                                    "v-permission:BusinessPurchaseReturnInform_Return",
                                  arg: "BusinessPurchaseReturnInform_Return",
                                },
                              ],
                              attrs: {
                                type: "primary",
                                disabled: tableOperationProp.notSingle,
                              },
                              on: { click: _vm.onDeliver },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "BusinessPurchaseReturnComPage.returnWarehouse"
                                  )
                                )
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: _vm.isInform
                              ? "BusinessPurchaseReturnInform_Export"
                              : "BusinessPurchaseReturnResult_Export",
                            expression:
                              "\n            isInform\n              ? 'BusinessPurchaseReturnInform_Export'\n              : 'BusinessPurchaseReturnResult_Export'\n          ",
                          },
                        ],
                        attrs: { type: "primary" },
                        on: { click: _vm.onExport },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("BusinessPurchaseReturnComPage.export"))
                        ),
                      ]
                    ),
                  ],
                  2
                ),
              ]
            },
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "code"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "link",
                                            on: {
                                              click: function ($event) {
                                                return _vm.onDetail(row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(row[col.prop]) + " "
                                            ),
                                          ]
                                        )
                                      : col.prop === "stockoutCode"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "link",
                                            on: {
                                              click: function ($event) {
                                                return _vm.onInformDetail(row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(row[col.prop]) + " "
                                            ),
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                row[col.prop],
                                                row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName:
                                              "v-permission:BusinessPurchaseReturnIndex_Edit",
                                            arg: "BusinessPurchaseReturnIndex_Edit",
                                          },
                                        ],
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEdit(row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("editText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }